<template>
    <div class="login-container">
    </div>
</template>
<script>
import {mapMutations} from "vuex";
import AuthService from "../../new/services/AuthService";

export default {

    name: "FederatedTokenLogin",
    computed: {
        token() {
            return this.$route.params.token ?? '';
        },
    },
    methods: {
        goToTheDashboard: function () {
            /* Delay for setting cookies */
            setTimeout(() => {
                this.$router.push(this.$enums.RoutePathEnum.DASHBOARD);
            }, 10);
        },
        ...mapMutations('app', {
            setGlobalLoadingState: 'setGlobalLoadingState',
        })
    },
    mounted() {
        this.setGlobalLoadingState(true);
        this.$api.federatedTokenLogin({
            data: {
                token: this.token,
                grant_type: 'password',
            }
        }).then(({data}) => {
            AuthService.completeAuthentication(data);
        }).catch(() => {
            if (AuthService.deliverAuthFailureToOpener()) {
                return;
            }

            this.$router.push(this.$enums.RoutePathEnum.LOGIN);
        });
        this.setGlobalLoadingState(false);
    }
}
</script>
